const topDialog = state => {
    return state.dialogs[state.dialogs.length - 1];
};

export default {
    topDialog,
};
